import React, { useState, useEffect } from "react";
import ProductsTemplate from "../ProductsBanner";
import ProductsFeatureTemplate from "../ProductsFeatureTemplate";
import { justifyWallProductName } from "../../../../../utils";
import './LCDBorderLessProducts.css';

const LCDBorderLessProducts = props => {
    const productName = justifyWallProductName(window.location.pathname.split("/").pop());
    const [name, setName] = useState(undefined);
    const [image, setImage] = useState(undefined);
    const [featureImg, setFeatureImage] = useState(undefined);
    let icons = [];
    console.log('productName', productName);
    switch (productName) {
        case ("VideoWallWithCMSEmbedded"):
            icons = [
                require("../../../../../images/products/icon/canvas icon/product_icon_03.png"),
                require("../../../../../images/products/icon/canvas icon/product_icon_04.png"),
                require("../../../../../images/products/icon/canvas icon/product_icon_05.png"),
                require("../../../../../images/products/icon/canvas icon/product_icon_06.png")
            ];
            break;
        case ("VideoWallForMeetingRoom"):
            icons = [
                require("../../../../../images/products/icon/canvas icon/product_icon_03.png"),
                require("../../../../../images/products/icon/canvas icon/product_icon_05.png"),
                require("../../../../../images/products/icon/canvas icon/product_icon_06.png")
            ];
            break;
        default:
            icons = [
                require("../../../../../images/products/icon/wall icon/wall_icon_1.png"),
                require("../../../../../images/products/icon/wall icon/wall_icon_2.png"),
                require("../../../../../images/products/icon/wall icon/wall_icon_3.png"),
                require("../../../../../images/products/icon/wall icon/wall_icon_4.png"),
            ];
            break;
    };

    let feature = icons.map((i, n) => {
        let title = `${productName}-feature-txt${n + 1}`;
        let message = `${name}-feature${n + 1}`;
        let obj = { icon: i, title, message }
        return obj
    })

    useEffect(() => {
        window.scrollTo(0, 0);
        setName(productName);
        setImage(require(`../../../../../images/products/banner/${productName}.jpg`));
        setFeatureImage(productName);
        // setFeatureImage(require(`../../../../../images/products/spec/${productName}.jpg`));
        return () => { window.scrollTo(0, 0); sessionStorage.removeItem("currentProduct") }
    }, []);
    let description;
    let descriptionStyle;
    switch (name) {
        case ("VideoWallWithCMSEmbedded"):
            description = ["VideoWallWithCMSEmbedded-description1", "VideoWallWithCMSEmbedded-description2", "VideoWallWithCMSEmbedded-description3", "VideoWallWithCMSEmbedded-description4"];
            descriptionStyle = {
                color: "white",
                textShadow: "1px 1px #000",
            };
            break;
        case ("VideoWallForMeetingRoom"):
            description = ["VideoWallForMeetingRoom-description1", "VideoWallForMeetingRoom-description2", "VideoWallForMeetingRoom-description3", "VideoWallForMeetingRoom-description4"];
            descriptionStyle = {
                color: "black",
                backgroundColor: "rgba(255, 255, 255, .6)",
                right: 0,
                top: "8%",
                padding: "20px 45px 20px 20px"
            };
            break;
        case ("LEDWall"):
            description = ["LEDWall-description1"];
            descriptionStyle = {
                color: "white",
                paddingLeft: "10vw"
            };
            break;
        default:
    };
    return (
        <div className={`__d_product_${productName}`}>
            <ProductsTemplate image={image} description={description} descriptionStyle={descriptionStyle} />
            <ProductsFeatureTemplate
                image={featureImg}
                title={name}
                feature={feature}
            />
        </div>
    );
}

export default LCDBorderLessProducts;
